import { getDefaultState } from 'store/initialState';
import {
  EXPENSES,
  OptionUser,
  STEP_EIDV,
  STEP_ID_DOC_UPLOAD,
  STEP_FACIAL_BIOMETRICS_CONSENT,
  STEP_DVS_CONSENT,
} from '_config';
import {
  APOLLO_NETWORK_ERROR,
  APOLLO_GRAPHQL_ERROR,
  ANTI_MONEY_LAUNDERING_AND_PROOF_OF_INCOME,
  PROOF_OF_ADDRESS_AND_PROOF_OF_INCOME,
  POITYPE_PAYSLIP_UPLOAD,
  POITYPE_DOC_UPLOAD,
  POI_CHECK_REQUIRED,
  OKTA_LOGIN_AND_SEND_OTP_ERROR,
  BIOMETRICS_CONSENT_PENDING,
  BIOMETRICS_CHECK_REQUIRED,
} from 'store';
import {
  PENDING_CUSTOMER_ACCEPTANCE,
  PENDING,
  APPROVED,
  DECLINED,
  REFERRED,
  CONDITIONALLY_APPROVED,
  PROOF_OF_ADDRESS,
  PROOF_OF_INCOME,
  ANTI_MONEY_LAUNDERING,
  IDV_CHECK_REQUIRED,
} from 'store/constants';
import { isFeatureOn } from 'featureToggles';
import { institutions } from '_config/defaultFormValues';

const personalDetails = {
  valid: {
    title: 'MR',
    firstName: 'Rafael',
    hasMiddleName: 'no',
    middleName: '',
    lastName: 'Madams',
    dateOfBirth: {
      day: '25',
      month: '12',
      year: '1973',
    },
    hasNzDriverLicence: 'yes',
    idType: '',
    licenceNumber: 'AB123456',
    version: '123',
    idNumber: '',
    issuingCountry: '',
    expiryDate: {
      day: '1',
      month: '1',
      year: '2035',
    },
    relationshipStatus: 'MARRIED_DEFACTO',
    numberOfDependents: '0',
    dvsConsent: true,
  },
};

const contactDetails = {
  valid: {
    mobileNumber: '0201234567',
    emailAddress: 'mock@email.com',
    confirmEmail: 'mock@email.com',
  },
  'test-case-approved': {
    mobileNumber: '0201234567',
    emailAddress: 'APPLYUI_ORIG_TEST_APPR_A100@latitudefinancial.com',
    confirmEmail: 'APPLYUI_ORIG_TEST_APPR_A100@latitudefinancial.com',
  },
  'test-case-customer-acceptance': {
    mobileNumber: '0201234567',
    emailAddress: 'APPLYUI_ORIG_TEST_PCA_P01A@latitudefinancial.com',
    confirmEmail: 'APPLYUI_ORIG_TEST_PCA_P01A@latitudefinancial.com',
  },
  'test-case-declined': {
    mobileNumber: '0201234567',
    emailAddress: 'APPLYUI_ORIG_TEST_DECL_D03X@latitudefinancial.com',
    confirmEmail: 'APPLYUI_ORIG_TEST_DECL_D03X@latitudefinancial.com',
  },
  'test-case-referred': {
    mobileNumber: '0201234567',
    emailAddress: 'APPLYUI_ORIG_TEST_REFR_R70B@latitudefinancial.com',
    confirmEmail: 'APPLYUI_ORIG_TEST_REFR_R70B@latitudefinancial.com',
  },
  'test-case-system-unavailable': {
    mobileNumber: '0201234567',
    emailAddress: 'APPLYUI_ORIG_TEST_SERVICE_UNAVAILABLE@latitudefinancial.com',
    confirmEmail: 'APPLYUI_ORIG_TEST_SERVICE_UNAVAILABLE@latitudefinancial.com',
  },
  'test-case-conditionally-approved': {
    mobileNumber: '0201234567',
    emailAddress: 'APPLYUI_ORIG_TEST_CAPPR_C74B@latitudefinancial.com',
    confirmEmail: 'APPLYUI_ORIG_TEST_CAPPR_C74B@latitudefinancial.com',
  },
  'test-case-verifier-eligibility-true': {
    mobileNumber: '0201234567',
    emailAddress: 'APPLYUI_ORIG_TEST_VFR_ELG_TRUE_POI@latitudefinancial.com',
    confirmEmail: 'APPLYUI_ORIG_TEST_VFR_ELG_TRUE_POI@latitudefinancial.com',
  },
  'test-case-dvs-false-eidv-pass-poi-required': {
    mobileNumber: '0201234567',
    emailAddress: 'APPLYUI_ORIG_TEST_IDV_DVS_FALSE_PASS_POI@latitudefinancial.com',
    confirmEmail: 'APPLYUI_ORIG_TEST_IDV_DVS_FALSE_PASS_POI@latitudefinancial.com',
  },
  'test-case-dvs-true-eidv-pass-poi-required': {
    mobileNumber: '0201234567',
    emailAddress: 'APPLYUI_ORIG_TEST_IDV_DVS_TRUE_PASS_POI@latitudefinancial.com',
    confirmEmail: 'APPLYUI_ORIG_TEST_IDV_DVS_TRUE_PASS_POI@latitudefinancial.com',
  },
  'test-case-eidv-passport-pass-poi-required': {
    mobileNumber: '0201234567',
    emailAddress: 'APPLYUI_ORIG_TEST_IDV_PASSPORT_PASS_POI@latitudefinancial.com',
    confirmEmail: 'APPLYUI_ORIG_TEST_IDV_PASSPORT_PASS_POI@latitudefinancial.com',
  },
  'test-case-eidv-medicare-pass-poi-required': {
    mobileNumber: '0201234567',
    emailAddress: 'APPLYUI_ORIG_TEST_IDV_MEDICARE_PASS_POI@latitudefinancial.com',
    confirmEmail: 'APPLYUI_ORIG_TEST_IDV_MEDICARE_PASS_POI@latitudefinancial.com',
  },
  'test-case-eidv-none-pass-poi-required': {
    mobileNumber: '0201234567',
    emailAddress: 'APPLYUI_ORIG_TEST_IDV_NONE_PASS_POI@latitudefinancial.com',
    confirmEmail: 'APPLYUI_ORIG_TEST_IDV_NONE_PASS_POI@latitudefinancial.com',
  },
  'test-case-eidv-required-poi-required': {
    mobileNumber: '0201234567',
    emailAddress: 'APPLYUI_ORIG_TEST_IDV_FAIL_AML_POI@latitudefinancial.com',
    confirmEmail: 'APPLYUI_ORIG_TEST_IDV_FAIL_AML_POI@latitudefinancial.com',
  },
  'test-case-eidv-required': {
    mobileNumber: '0201234567',
    emailAddress: 'APPLYUI_ORIG_TEST_IDV_NONE_FAIL_AML@latitudefinancial.com',
    confirmEmail: 'APPLYUI_ORIG_TEST_IDV_NONE_FAIL_AML@latitudefinancial.com',
  },
  'test-case-all-steps-poa': {
    mobileNumber: '0201234567',
    emailAddress: 'APPLYUI_ORIG_TEST_ALL_STEPS@latitudefinancial.com',
    confirmEmail: 'APPLYUI_ORIG_TEST_ALL_STEPS@latitudefinancial.com',
  },
  'test-case-all-steps-bio': {
    mobileNumber: '0201234567',
    emailAddress: 'APPLYUI_ORIG_TEST_BIO_PASS@latitudefinancial.com',
    confirmEmail: 'APPLYUI_ORIG_TEST_BIO_PASS@latitudefinancial.com',
  },
  'error:lost-network': {
    applicationErrors: { type: OKTA_LOGIN_AND_SEND_OTP_ERROR, error: new Error('service unavailable') },
  },
  'error:service-unavailable': {
    applicationErrors: { type: '', error: new Error('service unavailable') },
  },
};

const latitudeId = {
  valid: {
    latitudeId: 'mock@email.com',
    password: '12Abc$^&',
  },
};

const verification = {
  valid: {
    verificationCode: '123456',
  },
};

const password = {
  valid: {
    password: 'Abc123',
  },
};

const otherDetails = {
  valid: {
    residentialStatus: 'HOME_OWNER',
    lengthOfCurrentResidency: {
      years: '3',
      months: '0',
    },
    isPostalSameWithResidential: 'yes',
    hasNonDomesticPreviousAddress: false,
    currentAddress: {
      useManualAddress: false,
      address: {
        addressType: 'STREET_ADDRESS',
        poBoxNumber: '',
        propertyName: '',
        unitNumber: '',
        streetNumber: '49',
        streetName: 'Auckland',
        streetType: 'Road',
        suburb: 'Manurewa',
        city: 'Auckland',
        postcode: '1010',
        countryCode: 'NZ',
      },
    },
    previousAddress: {
      useManualAddress: false,
      address: {
        addressType: '',
        poBoxNumber: '',
        propertyName: '',
        unitNumber: '',
        streetNumber: '',
        streetName: '',
        streetType: '',
        suburb: '',
        city: '',
        postcode: '',
        countryCode: 'NZ',
      },
    },
    postalAddress: {
      useManualAddress: false,
      address: {
        addressType: '',
        poBoxNumber: '',
        propertyName: '',
        unitNumber: '',
        streetNumber: '',
        streetName: '',
        streetType: '',
        suburb: '',
        city: '',
        postcode: '',
        countryCode: 'NZ',
      },
    },
  },
};
const extraDetails = {
  valid: {
    relationshipStatus: 'MARRIED_DEFACTO',
    numberOfDependents: '0',
    idType: 'NZ_DRIVERS_LICENCE',
    licenceNumber: 'AB123456',
    idNumber: '',
    version: '453',
    expiryDate: {
      day: '01',
      month: '01',
      year: '2030',
    },
    nzResidencyNumber: '',
    issuingCountry: '',
  },
};

// TODO update this with correct value
// https://di.latitudefinancial.com/jira/browse/NZP-518
const employmentDetails = {
  valid: {
    occupation: 'IT',
    industry: 'COMPUTER_STAFF',
    employerName: 'Latitude',
    lengthOfTimeAtCurrentEmployer: {
      years: '1',
      months: '0',
    },
    lengthOfUnemployment: {
      years: '',
      months: '',
    },
    income: {
      amount: '4000',
      frequency: 'monthly',
    },
    incomeSource: '',
    employmentStatus: 'PERMANENT_FULL_TIME',
    hasOtherIncome: 'yes',
    otherEmploymentStatus: 'RENTAL_INCOME',
    otherIncome: {
      amount: '1000',
      frequency: 'monthly',
    },
    incomeAdjustmentRequired: 'no',
    conditionalStop: 'no',
  },
};
const expensesDetails = {
  valid: {
    isSummaryExpenses: 'no',
    isExpensesShared: 'no',
    // Your residential expenses
    primaryPropertyMortgageRentBoard: {
      amount: '2000',
      frequency: 'monthly',
    },
    propertyUtilitiesOther: {
      amount: '100',
      frequency: 'monthly',
    },
    // Your living expenses
    foodGroceriesLifestyleEntertainment: {
      amount: '200',
      frequency: 'monthly',
    },
    generalInsurance: {
      amount: '300',
      frequency: 'monthly',
    },
    transport: {
      amount: '400',
      frequency: 'monthly',
    },
    educationChildcare: {
      amount: '500',
      frequency: 'monthly',
    },
    personalFitnessMedical: {
      amount: '600',
      frequency: 'monthly',
    },
    other: {
      amount: '700',
      frequency: 'monthly',
    },
    basicExpenses: {
      amount: '',
      frequency: 'monthly',
    },
    additionalExpenses: {
      amount: '',
      frequency: 'monthly',
    },
  },
  summary: {
    isSummaryExpenses: 'yes',
    isExpensesShared: 'no',
    // Your residential expenses
    primaryPropertyMortgageRentBoard: {
      amount: '2000',
      frequency: 'monthly',
    },
    propertyUtilitiesOther: {
      amount: '0',
      frequency: 'monthly',
    },
    // Your living expenses
    foodGroceriesLifestyleEntertainment: {
      amount: '0',
      frequency: 'monthly',
    },
    generalInsurance: {
      amount: '0',
      frequency: 'monthly',
    },
    transport: {
      amount: '0',
      frequency: 'monthly',
    },
    educationChildcare: {
      amount: '0',
      frequency: 'monthly',
    },
    personalFitnessMedical: {
      amount: '0',
      frequency: 'monthly',
    },
    other: {
      amount: '0',
      frequency: 'monthly',
    },
    basicExpenses: {
      amount: '2000',
      frequency: 'monthly',
    },
    additionalExpenses: {
      amount: '1000',
      frequency: 'monthly',
    },
  },
};

const additionalDebtsDetails = {
  valid: {
    hasOtherDebts: 'no',
    totalCardLimits: '',
    loanRepayment: {
      amount: '',
      frequency: 'monthly',
    },
    secondaryPropertyMortgageRentBoard: {
      amount: '',
      frequency: 'monthly',
    },
  },
  hasDebts: {
    hasOtherDebts: 'yes',
    secondaryPropertyMortgageRentBoard: {
      amount: '100',
      frequency: 'monthly',
    },
    totalCardLimits: '100',
    amountOwingOnCreditCard: '100',
    loanRepayment: {
      amount: '100',
      frequency: 'monthly',
    },
    hasLoanLumpSumPayment: 'no',
    payLumpSumWithExistingSaving: '',
  },
};

const achDetails = {
  valid: {
    hasAch: 'yes',
    sameCurrentAddress: 'no',
    personalDetails: {
      title: 'MRS',
      firstName: 'Rachel',
      middleName: 'R',
      lastName: 'Madams',
      dateOfBirth: {
        day: '1',
        month: '8',
        year: '1975',
      },
      hasMiddleName: 'yes',
      mobileNumber: '0201234568',
      emailAddress: 'mock@email.com',
    },
    currentAddress: {
      useManualAddress: false,
      address: {
        addressType: 'STREET_ADDRESS',
        poBoxNumber: '',
        propertyName: '',
        unitNumber: '',
        streetNumber: '801',
        streetName: 'Kiwi',
        streetType: 'Road',
        suburb: 'Manurewa',
        city: 'Auckland',
        postcode: '1010',
        countryCode: 'NZ',
      },
    },
  },
  sameAddress: {
    hasAch: 'yes',
    sameCurrentAddress: 'yes',
    personalDetails: {
      title: 'MRS',
      firstName: 'Rachel',
      middleName: 'R',
      lastName: 'Madams',
      dateOfBirth: {
        day: '1',
        month: '8',
        year: '1975',
      },
      hasMiddleName: 'yes',
      mobileNumber: '0201234568',
      emailAddress: 'mock@email.com',
    },
    currentAddress: {
      useManualAddress: false,
      address: {
        addressType: '',
        poBoxNumber: '',
        propertyName: '',
        unitNumber: '',
        streetNumber: '',
        streetName: '',
        streetType: '',
        suburb: '',
        city: '',
        postcode: '',
        countryCode: '',
      },
    },
  },
};

const creditLimitDetails = {
  valid: {
    creditLimitSource: OptionUser,
    creditLimit: '5000',
  },
  declined: {
    creditLimit: '',
  },
  referred: {
    creditLimit: '',
  },
  conditionallyApproved: {
    creditLimit: '',
  },
};

const preferredCreditLimitDetails = {
  valid: {
    creditLimit: '5000',
  },
  declined: {
    creditLimit: '2000',
  },
  referred: {
    creditLimit: '2000',
  },
  conditionallyApproved: {
    creditLimit: '2000',
  },
};

const creditLimitAcceptance = {
  valid: {
    creditLimit: '5000',
    accepted: true,
  },
};

const acceptance = {
  valid: {
    accepted: true,
  },
};

const eIDV = {
  nzDriversLicence: {
    idNumber: '',
    idType: 'NZ_DRIVERS_LICENCE',
    licenceNumber: 'AB123456',
    version: '123',
    expiryDate: { day: '01', month: '01', year: '2030' },
    dvsConsent: false,
  },
  nzPassport: {
    idType: 'NZ_PASSPORT',
    idNumber: 'AB123456',
    licenceNumber: '',
    version: '',
    expiryDate: { day: '01', month: '01', year: '2030' },
    dvsConsent: false,
  },
  auPassport: {
    idType: 'AU_PASSPORT',
    idNumber: 'AB123456',
    licenceNumber: '',
    version: '',
    expiryDate: { day: '01', month: '01', year: '2030' },
    dvsConsent: true,
  },
  nzBirthCertificate: {
    idType: 'NZ_BIRTH_CERTIFICATE',
    idNumber: '1234567890',
  },
  nzCitizenship: {
    idType: 'NZ_CITIZENSHIP',
    idNumber: '1234567890',
  },
};

export const balanceTransfer = {
  valid: {
    requestBalanceTransfer: 'yes',
    balanceTransferList: {
      bt0: {
        amount: '1200',
        institutionName: 'ANZ',
        billerCode: '6007',
        billerRef: '123456789012345',
      },
    },
    tncConsent: true,
    confirmationConsent: true,
  },
};

export const creditLimitRequest = {
  valid: {
    creditLimitOptions: 'ownCreditLimit',
    newCreditLimit: '5000',
  },
};

const confirmCreditLimit = {
  empty: {
    newCreditLimit: '',
    creditLimitOptions: null,
  },
  valid: {
    newCreditLimit: '',
    creditLimitOptions: 'acceptCreditLimit',
  },
  declined: {
    creditLimit: '',
  },
  referred: {
    creditLimit: '',
  },
  conditionallyApproved: {
    creditLimit: '',
  },
};

export const complete = {
  approved: {
    overview: isFeatureOn('promoCode')
      ? {
          promoCode: '',
          applicationReason: EXPENSES,
          consentGiven: true,
        }
      : {
          applicationReason: EXPENSES,
          consentGiven: true,
        },
    contactDetails: contactDetails.valid,
    latitudeId: latitudeId.valid,
    emailVerification: {
      verificationCode: '123456',
    },
    password: password.valid,
    personalDetails: personalDetails.valid,
    otherDetails: otherDetails.valid,
    extraDetails: extraDetails.valid,
    employmentDetails: employmentDetails.valid,
    expensesDetails: expensesDetails.valid,
    additionalDebtsDetails: additionalDebtsDetails.valid,
    creditLimitDetails: creditLimitDetails.valid,
    achDetails: achDetails.valid,
    preferredCreditLimitDetails: preferredCreditLimitDetails.valid,
    creditLimitAcceptance: creditLimitAcceptance.valid,
    acceptance: acceptance.valid,
    balanceTransfer: balanceTransfer.valid,
    confirmCreditLimit: confirmCreditLimit.valid,
    creditLimitRequest: creditLimitRequest.valid,
    balanceTransferInstitutions: {
      institutions,
    },
  },
  declined: {
    overview: isFeatureOn('promoCode')
      ? {
          promoCode: '',
          applicationReason: EXPENSES,
          consentGiven: true,
        }
      : {
          applicationReason: EXPENSES,
          consentGiven: true,
        },
    contactDetails: contactDetails.valid,
    password: password.valid,
    personalDetails: personalDetails.valid,
    otherDetails: otherDetails.valid,
    extraDetails: extraDetails.valid,
    employmentDetails: employmentDetails.valid,
    expensesDetails: expensesDetails.valid,
    additionalDebtsDetails: additionalDebtsDetails.valid,
    creditLimitDetails: creditLimitDetails.declined,
    creditLimitAcceptance: creditLimitAcceptance.valid,
    preferredCreditLimitDetails: preferredCreditLimitDetails.declined,
    balanceTransfer: balanceTransfer.valid,
    confirmCreditLimit: confirmCreditLimit.valid,
    creditLimitRequest: creditLimitRequest.valid,
  },
  referred: {
    overview: isFeatureOn('promoCode')
      ? {
          promoCode: '',
          applicationReason: EXPENSES,
          consentGiven: true,
        }
      : {
          applicationReason: EXPENSES,
          consentGiven: true,
        },
    contactDetails: contactDetails.valid,
    password: password.valid,
    personalDetails: personalDetails.valid,
    otherDetails: otherDetails.valid,
    extraDetails: extraDetails.valid,
    employmentDetails: employmentDetails.valid,
    expensesDetails: expensesDetails.valid,
    additionalDebtsDetails: additionalDebtsDetails.valid,
    creditLimitDetails: creditLimitDetails.referred,
    creditLimitAcceptance: creditLimitAcceptance.valid,
    preferredCreditLimitDetails: preferredCreditLimitDetails.referred,
    balanceTransfer: balanceTransfer.valid,
    confirmCreditLimit: confirmCreditLimit.valid,
    creditLimitRequest: creditLimitRequest.valid,
  },
  conditionallyApproved: {
    overview: isFeatureOn('promoCode')
      ? {
          promoCode: '',
          applicationReason: EXPENSES,
          consentGiven: true,
        }
      : {
          applicationReason: EXPENSES,
          consentGiven: true,
        },
    contactDetails: contactDetails.valid,
    password: password.valid,
    personalDetails: personalDetails.valid,
    otherDetails: otherDetails.valid,
    extraDetails: extraDetails.valid,
    employmentDetails: employmentDetails.valid,
    expensesDetails: expensesDetails.valid,
    additionalDebtsDetails: additionalDebtsDetails.valid,
    creditLimitDetails: creditLimitDetails.conditionallyApproved,
    creditLimitAcceptance: creditLimitAcceptance.valid,
    preferredCreditLimitDetails: preferredCreditLimitDetails.approved,
    balanceTransfer: balanceTransfer.valid,
    confirmCreditLimit: confirmCreditLimit.valid,
    creditLimitRequest: creditLimitRequest.valid,
  },
};

export const autofill = {
  overview: {
    'complete:approved': {
      activeStep: '/outcome',
      applicationSubmitted: true,
      applicationStatus: APPROVED,
      applicationErrors: null,
      applicationStartDate: new Date().toISOString(),
      gemVisaAccountNumber: '5218 9435 0015 199',
      acquisition: complete.approved,
    },
    'complete:declined': {
      activeStep: '/outcome',
      applicationSubmitted: true,
      applicationStatus: DECLINED,
      applicationErrors: null,
      applicationStartDate: new Date().toISOString(),
      acquisition: complete.declined,
    },
    'complete:referred': {
      activeStep: '/outcome',
      applicationSubmitted: true,
      applicationStatus: REFERRED,
      applicationErrors: null,
      applicationStartDate: new Date().toISOString(),
      acquisition: complete.referred,
    },
    'complete:INCOME_PAGE': {
      activeStep: '/verify-income',
      applicationSubmitted: true,
      applicationStatus: PENDING,
      applicationErrors: null,
      applicationStartDate: new Date().toISOString(),
      gemVisaAccountNumber: '5218 9435 0015 199',
      acquisition: complete.approved,
    },
    'complete:referred-upload-payslips': {
      activeStep: '/outcome',
      applicationSubmitted: true,
      incomeVerificationType: POITYPE_PAYSLIP_UPLOAD,
      applicationStatus: REFERRED,
      applicationErrors: null,
      applicationStartDate: new Date().toISOString(),
      acquisition: complete.referred,
    },
    'complete:referred-upload-documents': {
      activeStep: '/outcome',
      applicationSubmitted: true,
      incomeVerificationType: POITYPE_DOC_UPLOAD,
      applicationStatus: REFERRED,
      applicationErrors: null,
      applicationStartDate: new Date().toISOString(),
      acquisition: complete.referred,
    },
    'complete:conditionally-approved-poa': {
      activeStep: '/outcome',
      applicationSubmitted: true,
      applicationStatus: CONDITIONALLY_APPROVED,
      applicationStatusReason: PROOF_OF_ADDRESS,
      applicationErrors: null,
      applicationStartDate: new Date().toISOString(),
      acquisition: complete.conditionallyApproved,
      creditLimitApproved: 3000,
    },
    'complete:conditionally-approved-aml': {
      activeStep: '/outcome',
      applicationSubmitted: true,
      applicationStatus: CONDITIONALLY_APPROVED,
      applicationStatusReason: ANTI_MONEY_LAUNDERING,
      applicationErrors: null,
      applicationStartDate: new Date().toISOString(),
      acquisition: complete.conditionallyApproved,
      creditLimitApproved: 3000,
    },
    'complete:conditionally-approved-poi': {
      activeStep: '/outcome',
      applicationSubmitted: true,
      applicationStatus: CONDITIONALLY_APPROVED,
      applicationStatusReason: PROOF_OF_INCOME,
      applicationErrors: null,
      applicationStartDate: new Date().toISOString(),
      acquisition: complete.conditionallyApproved,
      creditLimitApproved: 3000,
    },
    'complete:conditionally-approved-poa-poi': {
      activeStep: '/outcome',
      applicationSubmitted: true,
      applicationStatus: CONDITIONALLY_APPROVED,
      applicationStatusReason: PROOF_OF_ADDRESS_AND_PROOF_OF_INCOME,
      applicationErrors: null,
      applicationStartDate: new Date().toISOString(),
      acquisition: complete.conditionallyApproved,
      creditLimitApproved: 3000,
    },
    'complete:conditionally-approved-aml-poi': {
      activeStep: '/outcome',
      applicationSubmitted: true,
      applicationStatus: CONDITIONALLY_APPROVED,
      applicationStatusReason: ANTI_MONEY_LAUNDERING_AND_PROOF_OF_INCOME,
      applicationErrors: null,
      applicationStartDate: new Date().toISOString(),
      acquisition: complete.conditionallyApproved,
      creditLimitApproved: 3000,
    },
    'complete:conditionally-approved-upload-doc-poa': {
      activeStep: '/outcome',
      applicationSubmitted: true,
      incomeVerificationType: POITYPE_PAYSLIP_UPLOAD,
      applicationStatus: CONDITIONALLY_APPROVED,
      applicationStatusReason: PROOF_OF_ADDRESS,
      creditLimitApproved: 3000,
      applicationRef: '1234 5678 9012 3456',
      applicationErrors: null,
      applicationStartDate: new Date().toISOString(),
      acquisition: complete.conditionallyApproved,
    },
    'complete:conditionally-approved-upload-doc-aml': {
      activeStep: '/outcome',
      applicationSubmitted: true,
      incomeVerificationType: POITYPE_DOC_UPLOAD,
      applicationStatus: CONDITIONALLY_APPROVED,
      applicationStatusReason: ANTI_MONEY_LAUNDERING,
      creditLimitApproved: 3000,
      applicationRef: '1234 5678 9012 3456',
      applicationErrors: null,
      applicationStartDate: new Date().toISOString(),
      acquisition: complete.conditionallyApproved,
    },
    'complete:conditionally-upload-payslips-poi': {
      activeStep: '/outcome',
      applicationSubmitted: true,
      incomeVerificationType: POITYPE_PAYSLIP_UPLOAD,
      applicationStatus: CONDITIONALLY_APPROVED,
      applicationStatusReason: PROOF_OF_INCOME,
      creditLimitApproved: 3000,
      applicationRef: '1234 5678 9012 3456',
      applicationErrors: null,
      applicationStartDate: new Date().toISOString(),
      acquisition: complete.conditionallyApproved,
    },
    'complete:conditionally-upload-payslips-aml-poi': {
      activeStep: '/outcome',
      applicationSubmitted: true,
      incomeVerificationType: POITYPE_PAYSLIP_UPLOAD,
      applicationStatus: CONDITIONALLY_APPROVED,
      applicationStatusReason: ANTI_MONEY_LAUNDERING_AND_PROOF_OF_INCOME,
      creditLimitApproved: 3000,
      applicationRef: '1234 5678 9012 3456',
      applicationErrors: null,
      applicationStartDate: new Date().toISOString(),
      acquisition: complete.conditionallyApproved,
    },
    'complete:conditionally-upload-payslips-poa-poi': {
      activeStep: '/outcome',
      applicationSubmitted: true,
      incomeVerificationType: POITYPE_PAYSLIP_UPLOAD,
      applicationStatus: CONDITIONALLY_APPROVED,
      applicationStatusReason: PROOF_OF_ADDRESS_AND_PROOF_OF_INCOME,
      creditLimitApproved: 3000,
      applicationRef: '1234 5678 9012 3456',
      applicationErrors: null,
      applicationStartDate: new Date().toISOString(),
      acquisition: complete.conditionallyApproved,
    },
    'complete:conditionally-upload-documents-poi': {
      activeStep: '/outcome',
      applicationSubmitted: true,
      incomeVerificationType: POITYPE_DOC_UPLOAD,
      applicationStatus: CONDITIONALLY_APPROVED,
      applicationStatusReason: PROOF_OF_INCOME,
      creditLimitApproved: 3000,
      applicationRef: '1234 5678 9012 3456',
      applicationErrors: null,
      applicationStartDate: new Date().toISOString(),
      acquisition: complete.conditionallyApproved,
    },
    'complete:conditionally-upload-documents-aml-poi': {
      activeStep: '/outcome',
      applicationSubmitted: true,
      incomeVerificationType: POITYPE_DOC_UPLOAD,
      applicationStatus: CONDITIONALLY_APPROVED,
      applicationStatusReason: ANTI_MONEY_LAUNDERING_AND_PROOF_OF_INCOME,
      creditLimitApproved: 3000,
      applicationRef: '1234 5678 9012 3456',
      applicationErrors: null,
      applicationStartDate: new Date().toISOString(),
      acquisition: complete.conditionallyApproved,
    },
    'complete:conditionally-upload-documents-poa-poi': {
      activeStep: '/outcome',
      applicationSubmitted: true,
      incomeVerificationType: POITYPE_DOC_UPLOAD,
      applicationStatus: CONDITIONALLY_APPROVED,
      applicationStatusReason: PROOF_OF_ADDRESS_AND_PROOF_OF_INCOME,
      creditLimitApproved: 3000,
      applicationRef: '1234 5678 9012 3456',
      applicationErrors: null,
      applicationStartDate: new Date().toISOString(),
      acquisition: complete.conditionallyApproved,
    },
    'go-to:processing': {
      activeStep: '/processing',
      applicationSubmitted: true,
      applicationStatus: POI_CHECK_REQUIRED,
      applicationErrors: null,
      applicationStartDate: new Date().toISOString(),
      gemVisaAccountNumber: '5218 9435 0015 199',
      acquisition: complete.approved,
    },
    'go-to:commitments': {
      activeStep: '/commitments',
      applicationStatus: '',
      applicationErrors: null,
      applicationStartDate: new Date().toISOString(),
      acquisition: {
        ...complete.approved,
        acceptance: { accepted: false },
      },
    },
    'go-to:credit-limit-details': {
      activeStep: '/credit-limit-details',
      applicationStatus: 'CREATED',
      applicationErrors: null,
      applicationStartDate: new Date().toISOString(),
      acquisition: {
        ...complete.approved,
      },
    },
    'go-to:balance-transfer': {
      activeStep: '/balance-transfer',
      applicationStatus: '',
      applicationErrors: null,
      applicationStartDate: new Date().toISOString(),
      acquisition: {
        ...complete.approved,
        acceptance: { accepted: false },
        creditLimitRequest: {
          creditLimitOptions: '',
          newCreditLimit: '',
        },
        additionalDebtsDetails: additionalDebtsDetails.hasDebts,
        achDetails: {
          hasAch: null,
          sameCurrentAddress: 'yes',
          personalDetails: {
            hasMiddleName: 'no',
            title: '',
            firstName: '',
            lastName: '',
            middleName: '',
            dateOfBirth: {
              day: '',
              month: '',
              year: '',
            },
            mobileNumber: '',
            emailAddress: '',
          },
          currentAddress: {
            useManualAddress: false,
            address: {
              unitNumber: '',
              streetNumber: '',
              streetName: '',
              streetType: '',
              suburb: '',
              postcode: '',
              poBoxNumber: '',
              addressType: '',
              countryCode: '',
              state: '',
              city: '',
            },
          },
        },
      },
      offer: {
        type: 'BALANCE_TRANSFER',
      },
    },
    'go-to:idv-consent': {
      activeStep: STEP_DVS_CONSENT,
      applicationStatus: IDV_CHECK_REQUIRED,
      isEmailVerified: true,
      isLatitudeIdPasswordSet: true,
      applicationSubmitted: true,
      applicationStartDate: new Date().toISOString(),
      applicationErrors: null,
      acquisition: complete.approved,
    },
    'go-to:eIDV': {
      activeStep: STEP_EIDV,
      applicationStatus: IDV_CHECK_REQUIRED,
      isEmailVerified: true,
      isLatitudeIdPasswordSet: true,
      applicationSubmitted: true,
      applicationStartDate: new Date().toISOString(),
      applicationErrors: null,
      acquisition: complete.approved,
    },
    'go-to:id-doc-upload': {
      activeStep: STEP_ID_DOC_UPLOAD,
      applicationStatus: IDV_CHECK_REQUIRED,
      isEmailVerified: true,
      isLatitudeIdPasswordSet: true,
      applicationSubmitted: true,
      applicationStartDate: new Date().toISOString(),
      applicationErrors: null,
      acquisition: complete.approved,
      idvAttempt: {
        NZDriversLicence: true,
      },
    },
    'go-to:bio-consent': {
      activeStep: STEP_FACIAL_BIOMETRICS_CONSENT,
      applicationStatus: BIOMETRICS_CONSENT_PENDING,
      isEmailVerified: true,
      isLatitudeIdPasswordSet: true,
      applicationSubmitted: true,
      applicationStartDate: new Date().toISOString(),
      applicationErrors: null,
      acquisition: complete.approved,
    },
    'go-to:processing-biometrics': {
      activeStep: '/processing-biometrics',
      applicationSubmitted: true,
      applicationStatus: BIOMETRICS_CHECK_REQUIRED,
      applicationErrors: null,
      isEmailVerified: true,
      isLatitudeIdPasswordSet: true,
      applicationStartDate: new Date().toISOString(),
      gemVisaAccountNumber: '5218 9435 0015 199',
      maskedMobileNumber: '044 *** 234',
      acquisition: complete.approved,
    },
    'final-step:pca': {
      activeStep: '/acceptance',
      applicationStatus: PENDING_CUSTOMER_ACCEPTANCE,
      applicationSubmitted: true,
      applicationErrors: null,
      applicationStartDate: new Date().toISOString(),
      acquisition: {
        ...complete.approved,
        acceptance: { accepted: false },
      },
      creditLimitApproved: 4000,
    },
    'final-step:error': {
      activeStep: '/credit-limit',
      applicationStatus: PENDING,
      applicationStartDate: new Date().toISOString(),
      applicationErrors: {
        type: APOLLO_GRAPHQL_ERROR,
        error: {
          graphQLErrors: {
            message: 'address is invalid',
          },
        },
      },
      acquisition: {
        ...complete.approved,
        acceptance: { accepted: false },
      },
    },
    'final-step:error-with-retry': {
      activeStep: '/credit-limit',
      applicationStatus: PENDING,
      applicationStartDate: new Date().toISOString(),
      applicationErrors: {
        type: APOLLO_NETWORK_ERROR,
        error: {
          networkError: {
            bodyText: 'Bad Gateway',
          },
        },
      },
      acquisition: {
        ...complete.approved,
        acceptance: { accepted: false },
      },
    },
    'final-step:error-with-retry-application-id': {
      activeStep: '/credit-limit',
      applicationStatus: PENDING,
      applicationStartDate: new Date().toISOString(),
      applicationErrors: {
        type: APOLLO_NETWORK_ERROR,
        error: {
          networkError: {
            bodyText: 'Bad Gateway',
          },
        },
      },
      acquisition: {
        ...complete.approved,
        acceptance: { accepted: false },
      },
    },
  },
  contactDetails,
  latitudeId,
  verification,
  password,
  personalDetails,
  otherDetails,
  extraDetails,
  expensesDetails,
  employmentDetails,
  additionalDebtsDetails,
  achDetails,
  creditLimitDetails: { valid: creditLimitDetails.valid },
  preferredCreditLimitDetails: { valid: preferredCreditLimitDetails.valid },
  creditLimitAcceptance: { valid: creditLimitAcceptance.valid },
  emailVerification: { valid: complete.approved.emailVerification },
  acceptance,
  eIDV,
  balanceTransfer,
  creditLimitRequest,
  reset: getDefaultState(),
};
